/*
  Sort by, the house list (round 27). snippets/vr-sort.liquid writes the select, a button and the list of orders;
  on a desktop with a mouse the button and the list stand in for the select (the styles decide, at the end of
  assets/component-facets.css) and this file makes them work. The box opens the list; a click, Enter or Space
  chooses; Escape, Tab or a click anywhere else closes it; the arrows, Home and End move through the orders, the
  one in hand shown in the gold sheen. The choice is written into the select, which tells the filter form
  (assets/facets.js) just as the select itself would, and the form redraws the grid and this box with it.
*/
(function () {
  'use strict';
  if (!window.customElements || customElements.get('vr-sort')) return;

  class VrSort extends HTMLElement {
    connectedCallback() {
      if (this.wired || this.classList.contains('vr-sort--native')) return;
      this.select = this.querySelector('select');
      this.button = this.querySelector('.vr-sort__button');
      this.list = this.querySelector('.vr-sort__list');
      if (!this.select || !this.button || !this.list) return;
      this.wired = true;
      this.options = Array.prototype.slice.call(this.list.querySelectorAll('.vr-sort__option'));
      this.value = this.button.querySelector('.vr-sort__value');
      this.active = -1;
      this.onOutside = this.onOutside.bind(this);

      this.button.addEventListener('click', () => (this.isOpen() ? this.close(true) : this.open()));
      this.button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || (event.altKey && event.key === 'ArrowDown')) {
          event.preventDefault();
          this.open();
        }
      });
      this.list.addEventListener('keydown', (event) => this.onKey(event));
      this.list.addEventListener('click', (event) => {
        const option = event.target.closest('.vr-sort__option');
        if (option) this.choose(this.options.indexOf(option));
      });
      this.list.addEventListener('mousemove', (event) => {
        const option = event.target.closest('.vr-sort__option');
        if (option) this.setActive(this.options.indexOf(option));
      });
      /* the words "Sort by" open the list too, as they would focus the select */
      this.label = document.getElementById(this.select.id + '-label');
      if (this.label) {
        this.onLabel = (event) => {
          if (getComputedStyle(this.button).display === 'none') return;
          event.preventDefault();
          this.button.focus();
          this.open();
        };
        this.label.addEventListener('click', this.onLabel);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onOutside, true);
      if (this.label && this.onLabel) this.label.removeEventListener('click', this.onLabel);
      this.wired = false;
    }

    isOpen() {
      return !this.list.hidden;
    }

    open() {
      if (this.isOpen()) return;
      this.list.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      let chosen = -1;
      this.options.forEach((option, i) => {
        if (option.getAttribute('aria-selected') === 'true') chosen = i;
      });
      this.setActive(Math.max(0, chosen));
      this.list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', this.onOutside, true);
    }

    close(backToButton) {
      if (!this.isOpen()) return;
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      this.list.removeAttribute('aria-activedescendant');
      this.setActive(-1);
      document.removeEventListener('pointerdown', this.onOutside, true);
      if (backToButton) this.button.focus({ preventScroll: true });
    }

    onOutside(event) {
      if (!this.contains(event.target)) this.close(false);
    }

    setActive(index) {
      if (index === this.active) return;
      if (this.options[this.active]) this.options[this.active].classList.remove('is-active');
      this.active = index;
      const option = this.options[index];
      if (!option) return;
      option.classList.add('is-active');
      this.list.setAttribute('aria-activedescendant', option.id);
    }

    onKey(event) {
      const last = this.options.length - 1;
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.setActive(Math.min(last, this.active + 1));
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.setActive(Math.max(0, this.active - 1));
          break;
        case 'Home':
          event.preventDefault();
          this.setActive(0);
          break;
        case 'End':
          event.preventDefault();
          this.setActive(last);
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.choose(this.active);
          break;
        case 'Escape':
          event.preventDefault();
          this.close(true);
          break;
        case 'Tab':
          this.close(false);
          break;
      }
    }

    choose(index) {
      const option = this.options[index];
      if (!option) return;
      this.options.forEach((each) => each.setAttribute('aria-selected', each === option ? 'true' : 'false'));
      this.value.textContent = option.textContent.trim();
      this.close(true);
      const value = option.getAttribute('data-value');
      if (this.select.value === value) return;
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('vr-sort', VrSort);
})();
